
export const A__FAKE_DB_SET    = 'action.fakeDb.set';
export const A__FAKE_DB_EDIT   = 'action.fakeDb.edit';
export const A__FAKE_DB_REMOVE = 'action.fakeDb.remove';
